export default "__VITE_ASSET__DP92_t15__"